import { EHttpMethods } from "../../../../enums";
import { AUTH_BASE_URL } from "../../../constants";
import { getToken } from "../../../context/authContext";
import { AuthConfig } from "../../../context/config/authConfig";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import {
  ACTION_DEACTIVE_AND_ACTIVE,
  LIST_PROFILES_URL,
  PROFILE_URL,
  REGISTRATION_PATH,
  USERS_URL,
} from "./constants";
import {
  IClientAdminBody,
  IClientAdminBodyResponse,
  IRegisterByPhoneRequest,
  IRegisterByPhoneResponse,
  IPinCodeRequestBody,
  ISetPinCodeResponse,
  IUpdateNationalIdRequestBody,
  IUpdateNationalIdResponse,
  IVerifyPincodeResponse,
  IUserAddressResponse,
  IUserInfoResponse,
  IUserAllAddressResponse,
  IUpdatePinCodeRequestBody,
  IUserAddressBody,
  IUserAllInfoResponse,
  IRequestResponse,
} from "./models";

// eslint-disable-next-line no-unused-vars
const defaultProvide = async () => await getToken();
const appProvide = async () => AuthConfig.getAppToken();

export const registerByPhone = (
  body: IRegisterByPhoneRequest
): Promise<IRegisterByPhoneResponse> => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}${REGISTRATION_PATH}`,
    "POST",
    appProvide
  );
  return fetchRequest(descriptor, body);
};

export const postUserPinCode = (
  userId: string,
  body: IPinCodeRequestBody
): Promise<ISetPinCodeResponse> => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}/api/users/${userId}/pin-code`,
    "POST",
    appProvide
  );
  return fetchRequest(descriptor, body);
};

export const getClientAdminOrgAdmin = (userId: string): Promise<any> => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}/api/users/orgAdmin/client/${userId}`,
    "GET",
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const updateNationalId = (
  userId: string,
  body: IUpdateNationalIdRequestBody
): Promise<IUpdateNationalIdResponse> => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}/api/users/${userId}/national-id`,
    "PATCH",
    defaultProvide
  );
  return fetchRequest(descriptor, body);
};
export const getBasicUserDetailsById = (
  id: string | number
): Promise<IUserInfoResponse> => {
  const url = `${AUTH_BASE_URL}${PROFILE_URL}/${id}/basic-info`;
  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};

export const verifyPinCode = (
  userId: string,
  body: IPinCodeRequestBody
): Promise<IVerifyPincodeResponse> => {
  const url = `${AUTH_BASE_URL}/api/users/${userId}/pin-code/verify`;
  const descriptor = new ApiServiceManager(url, "POST", defaultProvide);
  return fetchRequest(descriptor, body);
};

export const getUserAllAddress = (
  id: number
): Promise<IUserAllAddressResponse> => {
  const url = `${AUTH_BASE_URL}${PROFILE_URL}/${id}/addresses`;
  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};

export const getAllUsers = (
  page = 0,
  size = 10,
  searchValue = ""
): Promise<any> => {
  const encoded = searchValue.replace("+", "%2B");
  const url = `${AUTH_BASE_URL}${LIST_PROFILES_URL}?searchKeyWord=${encoded}&page=${page}&size=${size}&sort=createdAt,DESC`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const getUserDetailsById = (
  id: string | number
): Promise<IUserAllInfoResponse> => {
  const url = `${AUTH_BASE_URL}${PROFILE_URL}/${id}`;
  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};

export const getClientAdmins = (
  page: number,
  size: number
): Promise<IClientAdminBodyResponse> => {
  const url = `${AUTH_BASE_URL}/v2/api/users/client-admins?page=${page}&size=${size}`;
  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};

export const createClientAdmin = (body: Partial<IClientAdminBody>) => {
  const url = `${AUTH_BASE_URL}/v2/api/users/client-admin-sign-up`;
  const descriptor = new ApiServiceManager(url, "POST", defaultProvide);
  return fetchRequest(descriptor, body);
};

// TODO: not ready
export const editClientAdmin = (
  id: string,
  body: Partial<IClientAdminBody>
) => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}/api/profiles/${id}/profile`,
    "PATCH",
    appProvide
  );
  return fetchRequest(descriptor, body);
};

export const editClientAdminPermissions = (
  id: number,
  body: Partial<IClientAdminBody>
) => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}/v2/api/users/${id}/client-admin-authorities`,
    "PUT",
    defaultProvide
  );
  return fetchRequest(descriptor, body);
};
